import { surveyFormsService } from "../../../../../Api/Services/SurveyFormsService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { IAssignInvitedUsersResponse } from "../../../../../Types/SurveyFormsTypes";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

export const fetchSurveyFormAssignedInvitedEmployees = createServiceAsyncThunk<
  IAssignInvitedUsersResponse,
  { formId: number; userIds: number[] }
>(
  ACTION_NAMES.FETCH_ASSIGN_SURVEY_FORM_TO_EMPLOYEES,
  ({ formId, userIds }) =>
    surveyFormsService.assignInvitedUsers(formId, userIds),
  ERROR_MESSAGES.FETCH_ASSIGN_SURVEY_FORM_TO_EMPLOYEES
);

const surveyFormAssignedInvitedEmployeesSlice = createGenericSlice<
  IAssignInvitedUsersResponse,
  { formId: number; userIds: number[] }
>(
  SLICE_NAMES.ASSIGN_SURVEY_FORM_TO_EMPLOYEES,
  fetchSurveyFormAssignedInvitedEmployees
);

export const {
  clearError: clearAssignedSurveyFormToEmployeesError,
  clearSuccessMessage: clearAssignedSurveyFormToEmployeesSuccess,
} = surveyFormAssignedInvitedEmployeesSlice.actions;

export default surveyFormAssignedInvitedEmployeesSlice.reducer;
